import { useEffect, useState } from 'react';
import Axios from 'axios';
import { message } from 'antd';
import { getTemplate, TemplatePageI } from 'app/adapters/TemplatePages';

const usePageData = (page: string) => {
  const [pageData, setPageData] = useState<TemplatePageI | null>(null);

  const getPageData = async (page: string) => {
    try {
      const { data } = await getTemplate({ slug__iexact: page });

      if (data?.results?.length) setPageData(data.results[0]);
    } catch (error) {
      if (!Axios.isCancel(error)) {
        message.error('An error occurred while fetching the page data');
      }
    }
  };

  useEffect(() => {
    getPageData(page);
  }, [page]);

  return { pageData };
};

export default usePageData;
